import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import 'element-ui/lib/theme-chalk/index.css'
import api from './api/api'
import util from './util/util'
import { saveStoreToSesstion } from "./api/store";
import echarts from 'echarts'

Vue.prototype.$echarts = echarts

import VueAreaLinkage from 'vue-area-linkage'
Vue.use(VueAreaLinkage)
Vue.prototype.$bus = new Vue()
Vue.config.productionTip = false
Vue.prototype.$api = api;
Vue.prototype.$util = util;

import {init} from "echarts"
Vue.prototype.$initEcharts = (el,opction)=>{const OM = init(el); OM.setOption(opction);return OM};

// import FullCalendar from '../src/components/vue-fullcalendars'
// Vue.use(FullCalendar)

// //路由权限控制
// router.beforeEach((to, from, next) => {
//   if (to.name != "login") {
//     if (sessionStorage.getItem("token")) {
//         if (to.path) {
//           if (window._hmt) {
//             _hmt.push(['_trackPageview', '/#' + to.fullPath]);
//             next();
//           }
//         }
        
//     } else {
//       next({ name: "login" })
//     }
//   } else {
//     next() //放行
//   }
// })


export default new Vue({
  router,
  store,
  created(){
    saveStoreToSesstion("mamamamama");//Vuex持久存储
  },
  render: h => h(App)
}).$mount('#app')

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
})